import { Dialogue, Link } from '@cognitranlimited/itis-web';
import React, { useEffect, useMemo } from 'react';
import { closeGieLinksDialogue, selectGieLinksDialogueParams, selectIsGieLinksDialogueOpen } from './gieLinksSlice';
import { useGieLinksContext } from './gieLinksContext';
import { useGieLinksSelector } from './gieLinksStore';
import './gieLinksDialogue.scss';
import { useGetDocumentProcedureTreeQuery } from './gieLinksModuleApi';
import { skipToken } from '@reduxjs/toolkit/query';
export var GieLinksDialogue = function () {
    var _a = useGieLinksContext(), strings = _a.strings, dispatch = _a.dispatch, navigation = _a.navigation, navigate = _a.navigate;
    var isOpen = useGieLinksSelector(selectIsGieLinksDialogueOpen);
    var params = useGieLinksSelector(selectGieLinksDialogueParams);
    var _b = useGetDocumentProcedureTreeQuery(isOpen && params ? {
        documentId: params.document.id,
        vehicle: params.document.vehicle
    } : skipToken), tree = _b.data, isError = _b.isError;
    var linksToShow = useMemo(function () {
        if (!params || !isOpen) {
            return [];
        }
        if (isError) {
            return params.links;
        }
        if (tree) {
            //flatten tree
            var treeNodeList_1 = flattenTreeItems(tree.tree);
            //check if links are in list
            var filteredlinks = params.links.filter(function (gieLink) {
                return treeNodeList_1.some(function (node) {
                    return node.procedureReference === gieLink.targetId;
                });
            });
            return filteredlinks;
        }
    }, [params, isOpen, isError, tree]);
    useEffect(function () {
        if (params && (linksToShow === null || linksToShow === void 0 ? void 0 : linksToShow.length) === 1) {
            var filteredLink = linksToShow[0];
            dispatch(closeGieLinksDialogue());
            navigate(navigation.document(params.document, {
                fragment: filteredLink.targetId
            }));
        }
    }, [dispatch, linksToShow, navigate, navigation, params]);
    if (!params || !linksToShow || linksToShow.length === 1) {
        return null; // Don't show the dialog if one item in list
    }
    function closeDialogue() {
        dispatch(closeGieLinksDialogue());
    }
    return React.createElement(Dialogue, { className: "GieLinksDialogue", isOpen: isOpen, onClose: closeDialogue },
        React.createElement(Dialogue.Header, { title: params.title, onClose: closeDialogue }),
        React.createElement(Dialogue.Content, null,
            strings.gieLinks.selectOption,
            React.createElement("ul", null, linksToShow.map(function (link) { return React.createElement("li", { key: link.targetId },
                React.createElement(Link, { href: navigation.document(params.document, { fragment: link.targetId }), onClick: closeDialogue }, link.description)); }))));
};
export function flattenTreeItems(items) {
    return items.flatMap(function (item) { return [item].concat(item.children ? flattenTreeItems(item.children) : []); });
}
